var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolderIcon5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2513_882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.36719 12.4035V24.0835L8.65969 26.5279V9.95898L4.36719 12.4035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9241 12.6746L9.76465 12.3275V11.166L10.9241 11.5131V12.6746Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8374 13.2344L11.6768 12.8873V11.7246L12.8374 12.0717V13.2344Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9241 14.9082L9.76465 14.5611V13.3984L10.9241 13.7455V14.9082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8374 15.4656L11.6768 15.1186V13.957L12.8374 14.3041V15.4656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9241 17.1414L9.76465 16.7943V15.6328L10.9241 15.9799V17.1414Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8374 17.7012L11.6768 17.3541V16.1914L12.8374 16.5385V17.7012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9241 19.3738L9.76465 19.0268V17.8652L10.9241 18.2123V19.3738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8374 19.9324L11.6768 19.5853V18.4238L12.8374 18.7709V19.9324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9241 21.6083L9.76465 21.2611V20.0996L10.9241 20.4467V21.6083Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8374 22.1679L11.6768 21.8209V20.6582L12.8374 21.0053V22.1679Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9241 23.8407L9.76465 23.4936V22.332L10.9241 22.6791V23.8407Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8374 24.3991L11.6768 24.052V22.8906L12.8374 23.2376V24.3991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9241 26.0761L9.76465 25.7291V24.5664L10.9241 24.9134V26.0761Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8374 26.6334L11.6768 26.2864V25.125L12.8374 25.472V26.6334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0391 6.60742V31.2943L20.08 34.7338V3.16797L14.0391 6.60742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9211 6.52836L21.2881 6.04015V4.4043L22.9211 4.89251V6.52836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6125 7.3135L23.9795 6.82531V5.18945L25.6125 5.67882V7.3135Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9211 9.66977L21.2881 9.18156V7.54688L22.9211 8.03509V9.66977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6125 10.4569L23.9795 9.96869V8.33398L25.6125 8.8222V10.4569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9211 12.8135L21.2881 12.3253V10.6895L22.9211 11.1788V12.8135Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6125 13.5995L23.9795 13.1113V11.4766L25.6125 11.9648V13.5995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9211 15.9561L21.2881 15.4667V13.832L22.9211 14.3202V15.9561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6125 16.7432L23.9795 16.2538V14.6191L25.6125 15.1073V16.7432Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9211 19.0995L21.2881 18.6113V16.9766L22.9211 17.4648V19.0995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6125 19.8846L23.9795 19.3964V17.7617L25.6125 18.2499V19.8846Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9211 22.2432L21.2881 21.755V20.1191L22.9211 20.6074V22.2432Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6125 23.0284L23.9795 22.5402V20.9043L25.6125 21.3926V23.0284Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9211 25.3846L21.2881 24.8965V23.2617L22.9211 23.75V25.3846Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6125 26.1697L23.9795 25.6817V24.0469L25.6125 24.5351V26.1697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.832 3.5667V29.1617L33.0958 32.7285V0L26.832 3.5667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0404 3.48398L34.3486 2.97726V1.28125L36.0404 1.78797V3.48398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8316 4.29728L37.1396 3.79056V2.0957L38.8316 2.60128V4.29728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0404 6.74062L34.3486 6.23506V4.53906L36.0404 5.04577V6.74062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8316 7.55507L37.1396 7.04952V5.35352L38.8316 5.86024V7.55507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0404 10.0004L34.3486 9.49368V7.79883L36.0404 8.3044V10.0004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8316 10.8148L37.1396 10.3081V8.61328L38.8316 9.11998V10.8148Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0404 13.2594L34.3486 12.7526V11.0566L36.0404 11.5634V13.2594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8316 14.0746L37.1396 13.5679V11.873L38.8316 12.3786V14.0746Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0404 16.516L34.3486 16.0105V14.3145L36.0404 14.8212V16.516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8316 17.3305L37.1396 16.8249V15.1289L38.8316 15.6356V17.3305Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0404 19.7758L34.3486 19.2691V17.5742L36.0404 18.0798V19.7758Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8316 20.5902L37.1396 20.0835V18.3887L38.8316 18.8954V20.5902Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0404 23.0348L34.3486 22.5281V20.832L36.0404 21.3387V23.0348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8316 23.8501L37.1396 23.3432V21.6484L38.8316 22.154V23.8501Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.527319 20.9277C0.527319 20.9277 -2.10916 37.941 11.616 41.6638C11.616 41.6638 8.54648 36.8258 8.51644 33.5887C8.51644 33.5887 10.982 38.8874 13.6658 40.9675C13.6658 40.9675 13.2859 35.9732 15.6048 31.7101C15.6048 31.7101 14.3102 27.4932 8.89176 25.8677C3.4733 24.2423 0.527319 20.9277 0.527319 20.9277Z",
    fill: "white",
    stroke: "#628A3F",
    strokeWidth: 0.65543,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9567 43.1174C13.9567 43.1174 11.8179 30.5327 22.2714 25.8242C32.725 21.1157 37.9668 23.5914 45.3184 16.8906C45.3184 16.8906 45.9213 28.8412 36.6423 37.5943C27.363 46.3474 15.4938 44.0534 15.4938 44.0534C15.4938 44.0534 21.5797 34.5171 27.8158 30.7443C27.8147 30.7433 19.4699 31.8608 13.9567 43.1174Z",
    fill: "white",
    stroke: "#628A3F",
    strokeWidth: 0.65543,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2513_882"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.6509,
    height: 44.7097,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon5);
export default __webpack_public_path__ + "static/media/folder_icon5.cb925539f79e6f39d86e612d69330d67.svg";
export { ForwardRef as ReactComponent };